import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPrometheusComponent } from './simple-icons-prometheus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPrometheusComponent ],
    exports:      [ SimpleIconsPrometheusComponent ],
    bootstrap:    []
})
export class SimpleIconsPrometheusModule {}
